import { Dialog, Margin } from '@spritz-finance/ui'
import React from 'react'
import styled from 'styled-components'
import { TocContent } from './tncContent'

interface TermsAndConditionsDialogProps {
    open: boolean
    onClose: () => void
}

const DialogContentWrapper = styled(Dialog.Content)`
    height: 600px;
    & > div {
        height: 100%;
        padding: 0;
    }
`

const DialogInnerContentWrapper = styled.div`
    overflow-y: scroll;
    padding: ${Margin.Med};
    height: calc(100% - 110px);
`

export const TermsAndConditionsDialog: React.VFC<TermsAndConditionsDialogProps> = ({
    open,
    onClose,
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContentWrapper minWidth={200}>
                <Dialog.Title>Terms And Conditions</Dialog.Title>
                <DialogInnerContentWrapper>
                    <TocContent />
                </DialogInnerContentWrapper>
            </DialogContentWrapper>
        </Dialog>
    )
}
